module.exports = __webpack_public_path__ + "static/media/grayscale-sketches.be3f7497.png";